export const NomenclaturesEndpoint = {
    nomenclature: `${process.env.API_BACKEND}/v1/nomenclatures/nomenclature/`,
    nomenclatureAvailableCount: `${process.env.API_BACKEND}/v1/bookings/order/booking/nomenclature/available`,
} as const
